import React from "react";
import { ShieldCheck, Layers, Headphones } from "lucide-react";
import { whyUs, teamImage, industrialImage } from "../mock";
import { Button } from "./ui/button";

const icons = [ShieldCheck, Layers, Headphones];

export default function WhyTidy() {
  return (
    <section id="why-tidy" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#e8a428] mb-4">
            Why Tidy
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#143527] mb-6">
            The difference is in the details.
          </h2>
          <p className="text-[16px] text-[#143527]/75 leading-relaxed">
            We combine the discipline of aviation maintenance with the warmth of hospitality service. The
            result is a cleaning experience that feels invisible — until you notice everything is, somehow,
            already perfect.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 lg:gap-8 mb-10">
          {whyUs.map((item, i) => {
            const Icon = icons[i];
            const bgs = ["#d6e4be", "#f4c5be", "#e8a428"];
            return (
              <div
                key={item.title}
                className="rounded-3xl p-8 lg:p-10 min-h-[260px] flex flex-col justify-between"
                style={{ backgroundColor: bgs[i] }}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#143527]/10 flex items-center justify-center mb-8">
                  <Icon className="w-7 h-7 text-[#143527]" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-serif text-2xl lg:text-3xl text-[#143527] mb-3">
                    {item.title}
                  </h3>
                  <p className="text-[14px] text-[#143527]/80 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mt-16">
          <div className="relative aspect-[16/10] rounded-3xl overflow-hidden">
            <img src={teamImage} alt="Professional cleaning team" className="w-full h-full object-cover" />
          </div>
          <div className="relative aspect-[16/10] rounded-3xl overflow-hidden">
            <img src={industrialImage} alt="Industrial floor cleaning" className="w-full h-full object-cover" />
          </div>
        </div>

        <div className="flex justify-center mt-12">
          <Button
            className="rounded-full px-8 py-6 btn-primary text-[15px]"
            onClick={() => {
              const el = document.getElementById("quote");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Book a walk-through
          </Button>
        </div>
      </div>
    </section>
  );
}
